import { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const HomePageLazy = lazyLoader(
  () => import('./Homepage' /* webpackChunkName: "homepage" */),
);

const HomePage = () => {
  return (
    <Suspense fallback={null}>
      <HomePageLazy />
    </Suspense>
  );
};

export default HomePage;
